<div class="head-w">
    <div class="offerschedule">
        <mat-icon class="unsetico">event</mat-icon>
        <span multilang class="offerscheduletext">
            <b>{{datas?.FeWoDetailsResponse?.Dauer + (datas?.FeWoDetailsResponse?.Dauer === '1' ? ' Nächt' : '
                Nächte')}}</b>
            {{datas?.FeWoDetailsResponse?.Anreise_Datum | date:'dd.MM.yyyy'}} -
            {{datas?.FeWoDetailsResponse?.Abreise_Datum | date:'dd.MM.yyyy'}}
        </span>
    </div>
    <div class="offerinfos">
        <div>
            <div class="f-name">
                <b>{{datas?.FeWoDetailsResponse?.Titel}}</b>
                <br>
                {{datas?.FeWoDetailsResponse?.Ort}}
                {{datas?.FeWoDetailsResponse?.Region_Name}}
                {{datas?.FeWoDetailsResponse?.Land_Name}}
            </div>
            <mat-divider></mat-divider>
            <div class="fdropw mbottom">
                <mat-icon class="ficon">bedroom_child</mat-icon>
                <span multilang class="fpadlr">Schlafzimmer {{datas?.FeWoDetailsResponse?.Schlafzimmer}}</span>
            </div>
            <div class="fdropw mbottom">
                <mat-icon class="ficon">group</mat-icon>
                <span multilang class="fpadlr">MaxPers. {{datas?.FeWoDetailsResponse?.MaxPers}}</span>
            </div>
            <div class="fdropw mbottom">
                <mat-icon class="ficon">pets</mat-icon>
                <span multilang class="fpadlr">Haustiere. {{datas?.FeWoDetailsResponse?.Haustiere?.length > 0 &&
                    datas?.FeWoDetailsResponse?.Haustiere !== '0' ? 'erlaubt' : 'nicht erlaubt'}}</span>
            </div>
        </div>
    </div>
    <div class="offerprice">
        <div>
            <span multilang *ngIf="datas?.FeWoDetailsResponse?.Erwachsene?.length > 0">Erwachsene :
                {{datas?.FeWoDetailsResponse?.Erwachsene}}</span>
            <span multilang style="margin-left: .5rem;" *ngIf="datas?.FeWoDetailsResponse?.Kinder?.length > 0">Kinder :
                {{datas?.FeWoDetailsResponse?.Kinder}}</span>
        </div>
        <div class="offerpriceTotal">
            <span multilang>Gesamtpreis:</span>
            <span multilang class="prccolor">{{datas?.FeWoDetailsResponse?.Preis | number:'1.2-2'}} EUR</span>
        </div>
    </div>
</div>